import HTTP from "@/_helpers/http";
import { BLOCKEDUSER__API } from "@/_helpers/urls";
import { BLOCKEDUSER__MUTATIONS } from "../mutation-types";
import { BLOCKEDUSER__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  accounts: [],
  isLoading: false,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [BLOCKEDUSER__MUTATIONS.BLOCKEDUSER](state, data) {
    state.accounts = data?.data?.accounts;
    state.pagination = data?.data?.pagination;
  },
};

// Actions
const actions = {
  async [BLOCKEDUSER__ACTIONS.BLOCKEDUSER]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);
      const {
        page = 1,
        limit = 10,
        search = "",
        duration
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(search && { search }),
        ...(duration && { duration })
      }).toString();

      const response = await HTTP().get(
        `${BLOCKEDUSER__API.BLOCKEDUSER}${queryParams ? `?${queryParams}` : ''}`
      );

      commit(BLOCKEDUSER__MUTATIONS.BLOCKEDUSER, response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },

  async [BLOCKEDUSER__ACTIONS.UNBLOCKUSER]({ commit, dispatch }, id) {
    try {
      const response = await HTTP().post(BLOCKEDUSER__API.UNBLOCKUSER, id);
      if (response.status === 200) {
        await dispatch(BLOCKEDUSER__MUTATIONS.BLOCKEDUSER);
        toast.success(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.success(error.response.data.message);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
